import React, { useState } from "react";
import "./CreateTaskPopup.css";

interface ICreateTaskPopupProps {
    onClose: ()=>void;
    onSave: (data: string)=>void;
    onSaveDraft: ()=>void;
}

export const CreateTaskPopup = ({onClose, onSave, onSaveDraft}: ICreateTaskPopupProps) => {
    const [text, setText] = useState('');

    return (
        <div className="createTask_shadow">
            <div className="createTask_popup">
                <div className="createTask_header">
                    <div className="createTask_title">
                        Create a new task
                    </div>
                    <div className="createTask_close" onClick={onClose}>
                        x
                    </div>
                </div>
                <textarea className="createTask_input" value={text} onChange={(e)=>setText(e.target.value)}></textarea>
                <div className="createTask_tags">
                    <div className="createTask_tags_icon">
                    
                    </div>
                    <div className="createTask_tags_list">
                
                    </div>
                    <div className="createTask_tags_add">
                
                    </div>
                </div>
                <div className="createTask_buttons">
                    <div className="createTask_button createTask_save" onClick={()=>onSave(text)}>
                        Done
                    </div>
                    <div className="createTask_button createTask_draft" onClick={onSaveDraft}>
                        Save draft
                    </div>
                </div>
            </div>
        </div>
    )
}